// 絵文字データの遅延ロード
// 起動時ではなく、初めて絵文字が必要になったタイミング（リアクション表示やピッカー表示）で
// データの読み込みとマップ構築を行う。一度ロードしたらキャッシュして再利用する。
let _emojiData = null;
let _map = null;

// 初回呼び出し時に @emoji-mart/data と emoji_data_ja をロードする
const getEmojiData = () => {
  if (_emojiData) return _emojiData;

  _emojiData = require('@emoji-mart/data');
  const { emojisJa, customCategory, hiraganaSyllabaryCategory } = require('./emoji_data_ja');

  // 絵文字日本語版を上書き
  _emojiData.emojis = emojisJa;
  // カスタムしたカテゴリーを追加
  _emojiData.categories.unshift(customCategory);
  _emojiData.categories.push(hiraganaSyllabaryCategory);

  return _emojiData;
};

// 初回呼び出し時に絵文字の検索用マップを構築する
const getMap = () => {
  if (_map) return _map;

  let emoji_data = getEmojiData();
  _map = Object.keys(emoji_data.emojis).map((key) => {
    let emoji = emoji_data.emojis[key];
    return {
      name : emoji.name,
      value : emoji.skins[0]?.native,
      id: emoji.id,
      type: emoji.type || 'emoji',
    }
  });
  // 旧emojiを使っている箇所がバグらないようにmapに追加
  _map = _map.concat(emoji.oldEmojis);
  return _map;
};

const emoji = {
  get emojiData() { return getEmojiData(); },
  get _map() { return getMap(); },
  // 取得
  getEmoji(name) {
    return this._map.find(v => v.name === name).value;
  },
  getEmojiObj(name) {
    return this._map.find(v => v.name === name);
  },
  // 選択
  getSelectData(emoji) {
    return {
      type: !!emoji.src ? 'image' : 'emoji',
      name : emoji.name,
      value : emoji.native,
    };
  },
  // 除外絵文字(最新の絵文字すぎて反映されないもの)
  exceptEmojis: [
    'melting_face',
    'dotted_line_face',
    'mirror_ball',
    'face_with_open_eyes_and_hand_over_mouth',
    'face_with_peeking_eye',
    'saluting_face',
    'rightwards_hand',
    'face_holding_back_tears',
    'face_with_diagonal_mouth',
    'hand_with_index_finger_and_thumb_crossed',
    'palm_down_hand',
    'leftwards_hand',
    'biting_lip',
    'heart_hands',
    'index_pointing_at_the_viewer',
    'leftwards_hand',
    'coral',
    'lotus',
    'empty_nest',
    'nest_with_eggs',
    'beans',
    'pouring_liquid',
    'jar',
    'playground_slide',
    'wheel',
    'ring_buoy',
    'hamsa',
    'low_battery',
    'crutch',
    'x-ray',
    'bubbles',
    'identification_card',
    'heavy_equals_sign',
    'troll',
  ],
  // 読み込み(受け取った要素の子要素にpickerを生成)
  load(node, options) {
    // ピンのSVG
    const PIN_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.9997 5.6463L10.353 1.99963C10.3071 1.95246 10.2521 1.91497 10.1914 1.88937C10.1307 1.86377 10.0655 1.85059 9.99969 1.85059C9.93382 1.85059 9.86863 1.86377 9.80794 1.88937C9.74726 1.91497 9.69232 1.95246 9.64635 1.99963L8.27302 3.33297C8.22585 3.37893 8.18836 3.43387 8.16276 3.49456C8.13716 3.55524 8.12397 3.62044 8.12397 3.6863C8.12397 3.75216 8.13716 3.81736 8.16276 3.87804C8.18836 3.93872 8.22585 3.99367 8.27302 4.03963L8.37302 4.1463L6.78635 5.75297L6.66635 5.6463C6.57267 5.5525 6.44558 5.49975 6.31302 5.49963C6.19445 5.50968 6.08335 5.56168 5.99969 5.6463L4.13969 7.47963C4.09251 7.5256 4.05502 7.58054 4.02943 7.64122C4.00383 7.70191 3.99064 7.7671 3.99064 7.83297C3.99064 7.89883 4.00383 7.96402 4.02943 8.02471C4.05502 8.08539 4.09251 8.14034 4.13969 8.1863L5.11969 9.17297L2.27302 13.0263C2.19858 13.1242 2.16227 13.2458 2.17085 13.3684C2.17944 13.4911 2.23234 13.6064 2.31969 13.693C2.41492 13.7844 2.54102 13.8368 2.67302 13.8396C2.78128 13.8401 2.8867 13.805 2.97302 13.7396L6.82635 10.893L7.81302 11.873C7.90677 11.9666 8.03385 12.0192 8.16635 12.0192C8.29885 12.0192 8.42594 11.9666 8.51969 11.873L10.353 9.99963C10.4467 9.90588 10.4992 9.7788 10.4992 9.6463C10.4992 9.5138 10.4467 9.38672 10.353 9.29297L10.2464 9.1863L11.8397 7.59963L11.9464 7.69963C12.0401 7.79327 12.1672 7.84586 12.2997 7.84586C12.4322 7.84586 12.5593 7.79327 12.653 7.69963L13.9997 6.35297C14.0469 6.307 14.0843 6.25206 14.1099 6.19137C14.1355 6.13069 14.1487 6.0655 14.1487 5.99963C14.1487 5.93377 14.1355 5.86858 14.1099 5.80789C14.0843 5.74721 14.0469 5.69226 13.9997 5.6463ZM5.01969 10.9796L5.80635 9.91297L6.08635 10.193L5.01969 10.9796ZM12.2997 6.6663L12.193 6.55963C12.0993 6.466 11.9722 6.41341 11.8397 6.41341C11.7072 6.41341 11.5801 6.466 11.4864 6.55963L9.18635 8.85963C9.09272 8.95338 9.04013 9.08047 9.04013 9.21297C9.04013 9.34547 9.09272 9.47255 9.18635 9.5663L9.29302 9.67297L8.16635 10.7996L5.19969 7.83297L6.32635 6.7063L6.43302 6.81297C6.5267 6.90676 6.65379 6.95952 6.78635 6.95963C6.91892 6.95952 7.04601 6.90676 7.13969 6.81297L9.43302 4.51297C9.52665 4.41922 9.57925 4.29213 9.57925 4.15963C9.57925 4.02713 9.52665 3.90005 9.43302 3.8063L9.33302 3.69963L9.99969 3.03297L12.9664 5.99963L12.2997 6.6663Z" fill="#1D284C"/></svg>';
    // カスタムカテゴリーのアイコン
    const categoryIcons = {
      custom: {
        svg: PIN_SVG,
      },
    };

    const { Picker } = require('emoji-mart');
    const picker = new Picker({ data: getEmojiData(), theme: 'light', categoryIcons, exceptEmojis: this.exceptEmojis, ...options });
    picker.classList.add('w-full', 'bg-white', 's-pb12', 's-pr8');
    node.appendChild(picker);
  },
  oldEmojis: [
    {
      type: 'emoji',
      name: 'smile',
      value: '😄',
    },
    {
      type: 'emoji',
      name: 'thumbsup',
      value: '👍',
    },
    {
      type: 'emoji',
      name: 'white_check_mark',
      value: '✅',
    },
    {
      type: 'emoji',
      name: 'appluse',
      value: '👏',
    },
    {
      type: 'emoji',
      name: 'ok_hand',
      value: '👌',
    },
    {
      type: 'emoji',
      name: 'bow',
      value: '🙇‍♂️'
    },
    {
      type: 'emoji',
      name: 'heart',
      value: '❤️',
    },
    {
      type: 'emoji',
      name: 'thinking',
      value: '🤔'
    },
    {
      type: 'emoji',
      name: 'fearful',
      value: '😨'
    },
    {
      type: 'emoji',
      name: 'cry',
      value: '😢'
    },
    {
      type: 'emoji',
      name: 'tada',
      value: '🎉'
    },
    {
      type: 'emoji',
      name: 'muscle',
      value: '💪'
    },
    {
      type: 'emoji',
      name: 'eyes',
      value: '👀'
    },
    {
      type: 'emoji',
      name: 'hundred_points',
      value: '💯',
    },
    {
      type: 'emoji',
      name: 'man_gesturing_ok',
      value: '🙆‍♂️'
    },
    {
      type: 'emoji',
      name: 'rocket',
      value: '🚀',
    },
    {
      type: 'emoji',
      name: 'unko',
      value: '💩',
    },
    {
      type: 'number',
      name: '0',
      value: '0️⃣',
    },
    {
      type: 'number',
      name: '1',
      value: '1️⃣',
    },
    {
      type: 'number',
      name: '2',
      value: '2️⃣',
    },
    {
      type: 'number',
      name: '3',
      value: '3️⃣',
    },
    {
      type: 'number',
      name: '4',
      value: '4️⃣',
    },
    {
      type: 'number',
      name: '5',
      value: '5️⃣',
    },
    {
      type: 'number',
      name: '6',
      value: '6️⃣',
    },
    {
      type: 'number',
      name: '7',
      value: '7️⃣',
    },
    {
      type: 'number',
      name: '8',
      value: '8️⃣',
    },
    {
      type: 'number',
      name: '9',
      value: '9️⃣',
    },
    {
      type: 'number',
      name: '10',
      value: '🔟️',
    },
  ],
};

export default emoji;
